import { Flex } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import { tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';

interface ISalesDataToolbarProps {
    table: Table<any>;
}

const SalesDataToolbar = ({ table }: ISalesDataToolbarProps) => {
    const { setGlobalFilter } = table;

    return (
        <Flex {...tableToolbarStyle}>
            <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
        </Flex>
    );
};

export default SalesDataToolbar;
